import React, { useState } from "react";
import { Button, Form, Input, Layout, message, Typography } from "antd";
import axios from "axios";

export default function Signup() {
  const [username, setUserName] = useState('');
  const [nickName, setNickName] = useState('');
  const [password, setPassword] = useState('');
  const [resultNickname, setResultNickname] = useState('');
  const [resultUsername, setResultUsername] = useState('')
  const [resultPassword, setResultPassword] = useState('');
  const [passwordValid, setPasswordValid] = useState(false);
  const [usernameValid, setUsernameValid] = useState(true);
  const [nicknameValid, setNicknameValid] = useState(true);


  function signup(userName, nickName, password) {
    if (passwordValid && !(usernameValid && nicknameValid)) {
      axios.post("/api/external/signup",
          {
            'userName': userName,
            'nickName': nickName,
            'password': password
          }).then((r) => r.data)
          .then(message.info("회원가입이 완료되었습니다."))
          .catch((e) => message.error(e))
    }
  }

  function checkPassword(checkedPassword) {
    if (password !== checkedPassword) {
      setResultPassword('비밀번호가 다릅니다.')
      setPasswordValid(false)
    } else {
      setResultPassword('비밀번호가 일치합니다.')
      setPasswordValid(true)
    }
  }

  function checkUsername() {
    if (username !== '') {
      axios.get("/api/external/check-username?userName=" + username)
          .then((r) => r.data)
          .then((r) => {
            r ? setResultUsername("사용 불가능한 아이디입니다.") :
                setResultUsername("사용 가능한 아이디입니다.");
            setUsernameValid(r);
          })
    } else {
      setResultUsername("아이디를 입력해주세요.")
    }
  }

  function checkNickname() {
    if (nickName !== '') {
      axios.get("/api/external/check-nickname?nickName=" + nickName)
          .then((r) => r.data)
          .then((r) => {
            r ? setResultNickname("사용 불가능한 닉네임입니다.") :
                setResultNickname("사용 가능한 닉네임입니다.");
            setNicknameValid(r);
          })
    } else {
      setResultNickname("닉네임을 입력해주세요.")
    }
  }

  return (
      <Layout>
        <Layout.Content>
          <div className="login-form">
            <form method={"post"} action={"/login"}>
              <br/>
              <br/>
              <br/>
              <Form.Item
                  label="ID"
                  name="username"
                  rules={[{required: true}]}
                  labelCol={{span: 8}}
                  wrapperCol={{span: 8}}
              >
                <Input
                    type='text'
                    placeholder='아이디를 입력해주세요.'
                    value={username}
                    onChange={(e) => setUserName(e.target.value)}
                />
                <Button onClick={checkUsername}>
                  중복확인
                </Button>
                <Typography.Text>
                  {resultUsername}
                </Typography.Text>
              </Form.Item>
              <Form.Item
                  label="Nickname"
                  name="nickName"
                  rules={[{required: true}]}
                  labelCol={{span: 8}}
                  wrapperCol={{span: 8}}
              >
                <Input
                    type='text'
                    placeholder='닉네임을 입력해주세요.'
                    value={nickName}
                    onChange={(e) => setNickName(e.target.value)}
                />
                <Button onClick={checkNickname}>
                  중복확인
                </Button>
                <Typography.Text>
                  {resultNickname}
                </Typography.Text>
              </Form.Item>
              <Form.Item
                  label="Password"
                  name="password"
                  rules={[{required: true}]}
                  labelCol={{span: 8}}
                  wrapperCol={{span: 8}}
              >
                <Input
                    type='password'
                    placeholder='비밀번호를 입력해주세요.'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Item>
              <Form.Item
                  label="checkPassword"
                  name="checkPassword"
                  rules={[{required: true}]}
                  labelCol={{span: 8}}
                  wrapperCol={{span: 8}}
              >
                <Input
                    type='password'
                    placeholder='비밀번호를 확인해주세요.'
                    onChange={(e) => checkPassword(e.target.value)}
                />
              </Form.Item>
              <div
                  style={{textAlign: 'center'}}
              >
                <Typography.Text>
                  {resultPassword}
                </Typography.Text>
              </div>
              <br/>
              <Form.Item wrapperCol={{offset: 8, span: 8}}>
                <Button
                    type={'primary'}
                    disabled={!passwordValid || usernameValid || nicknameValid}
                    onClick={() => signup(username, nickName, password)} block>
                  회원가입
                </Button>
              </Form.Item>
            </form>
          </div>
        </Layout.Content>
      </Layout>
  )
}